import { Code2, LoaderCircle } from 'lucide-react'
import type { MouseEventHandler, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Button } from './button'
import { Card } from './card'
import { CenteredLayout } from './centered-layout'

export function AuthLayout({
  brand,
  className,
  children,
}: {
  brand: ReactNode
  className?: string
  children: ReactNode
}) {
  return (
    <main data-slot="auth-layout">
      <CenteredLayout className={cn('relative overflow-hidden bg-background', className)}>
        <div className="pointer-events-none absolute -top-28 -left-24 size-80 rounded-full bg-accent/70 blur-3xl" />
        <div className="pointer-events-none absolute -right-28 -bottom-32 size-96 rounded-full bg-border/55 blur-3xl" />
        <div className="relative">
          <div className="mb-6 flex justify-center text-[2.125rem] leading-[1.2]">{brand}</div>
          <Card appearance="elevated" className="relative p-7 sm:p-9">
            {children}
          </Card>
        </div>
      </CenteredLayout>
    </main>
  )
}

export function DevAccessButton({
  label,
  pending = false,
  error,
  onClick,
}: {
  label: string
  pending?: boolean
  error?: ReactNode
  onClick: MouseEventHandler<HTMLButtonElement>
}) {
  return (
    <div className="absolute top-4 right-4">
      <Button
        appearance="outline"
        size="icon"
        aria-label={label}
        title={label}
        className="size-8 border-dashed bg-control p-0"
        pending={pending}
        onClick={onClick}
      >
        {pending ? (
          <LoaderCircle className="size-4 animate-spin motion-reduce:animate-none" />
        ) : (
          <Code2 className="size-4" />
        )}
      </Button>
      {error ? (
        <p className="absolute top-10 right-0 w-56 text-xs text-danger-foreground">{error}</p>
      ) : null}
    </div>
  )
}
